import theme from '../../lib/theme';
import { TravelCollectionProps } from './TravelCollection';

const {
  layouts,
  scale,
  colors,
} = theme;

export default ({isV2Collection}: TravelCollectionProps) => ({
  container: {
    ...layouts.column,

    alignItems: 'center',
    padding: `${isV2Collection ? 0 : scale.s} ${scale.xs} ${isV2Collection ? 0 : scale.l}`,
  },
  content: {
    '& a': {
      color: `${colors.sas.primary} !important`,
      border: '0 !important',
    },

    '& ul': {
      listStyleType: 'initial !important',
      border: '0 !important',
    },

    '& img': {
      width: 'auto !important',
      margin: '0 !important',
    },
  },
});
